import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { noop } from 'Helpers/PropTypes';

import 'react-table/react-table.css';
import './index.css';

class DataTable extends Component {
  constructor(props) {
    super(props);

    this.reactTable = React.createRef();
    this.onFilteredChange = this.onFilteredChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { data, onVisibleCountChange } = this.props;
    if (prevProps.data.length === data.length) {
      let mismatch = false;
      for (let i = 0; i < data.length; i++) {
        if (prevProps.data[i].id !== data[i].id) {
          mismatch = true;
          break;
        }
      }
      if (!mismatch) return;
    }

    onVisibleCountChange(
      this.reactTable.current.getResolvedState().sortedData.length,
    );
  }

  onFilteredChange(...args) {
    const { onFilteredChange, onVisibleCountChange } = this.props;
    let state = {
      sortedData: [],
    };
    if (this.reactTable.current) {
      state = this.reactTable.current.getResolvedState();
    }
    onFilteredChange(...args);
    onVisibleCountChange(state.sortedData.length);
  }

  render() {
    const passAlong = { ...this.props };
    if (passAlong.onVisibleCountChange) delete passAlong.onVisibleCountChange;
    if (passAlong.onFilteredChange) delete passAlong.onFilteredChange;
    return (
      <ReactTable
        getTheadThProps={() => ({
          style: { backgroundColor: '#F4F4F4', textAlign: 'left' },
        })}
        getTheadProps={() => ({
          style: { boxShadow: '0 0 0 0 rgba(0,0,0,0)' },
        })}
        getTheadFilterProps={() => ({ style: { backgroundColor: '#F4F4F4' } })}
        onFilteredChange={this.onFilteredChange}
        ref={this.reactTable}
        {...passAlong}
      />
    );
  }
}

DataTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onFilteredChange: PropTypes.func,
  onVisibleCountChange: PropTypes.func,
};

DataTable.defaultProps = {
  data: [],
  onFilteredChange: noop,
  onVisibleCountChange: noop,
};

export default DataTable;
